import React from "react";
import ArrowIcon from "../../../icons/arrow.icon";
import DoubleArrowIcon from "../../../icons/doble-arrow.icon";

export const ArrowIconComponent = ({ isPositive = true, isDouble = false, className = "" }) => (
  isDouble ? (
    <DoubleArrowIcon 
      fill={isPositive ? "#319F6B" : "#F36060"} 
      width={16} 
      height={16}
      className={className}
    />
  ) : ( 
  <ArrowIcon 
    fill={isPositive ? "#319F6B" : "#F36060"} 
    width={12} 
    height={12}
    style={{ transform: `rotate(${isPositive ? -45 : 45}deg)`, marginRight: '4px' }}
    className={className}
  />
)
);
